module.exports = __webpack_public_path__ + "img/RSS.709668fa.svg";